import { FROM, SEARCH, TO } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';

// Specific types for each filter field
export interface InvoiceUIFiltersReducer {
  filterByCustomer: boolean;
  [FROM]: string | null;
  [TO]: string | null;
  [SEARCH]: string | null;
}

const emptyState: InvoiceUIFiltersReducer = {
  filterByCustomer: true,
  [FROM]: null,
  [TO]: null,
  [SEARCH]: null
};

const filterAdapter = filterSliceAdapter(emptyState, {});

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_INVOICE_FILTER]: filterAdapter.setFilter,
  [types.SET_INVOICE_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_INVOICE_FILTERS]: filterAdapter.resetFilters,
  [types.REMOVE_INVOICE_FILTER]: filterAdapter.removeFilter,
  [types.CLOSE_INVOICE_MODAL]: filterAdapter.resetFilters
});
